import { createFeatureSelector, createSelector } from "@ngrx/store";
import { ReportViewsState, ReportViewState } from "./report-view.model";
import { AppSelectors } from "../../../_store/selector-types";
import { AppState } from "../../../_store/app-state.model";

export const selectReportViewsState = createFeatureSelector<ReportViewsState>('reportViews');

export const selectReportView = (props: { reportName: string }) =>
    createSelector(
        selectReportViewsState,
        (reportViewsState) => reportViewsState?.reports?.find(rv => rv.reportName === props.reportName)
    );

export const selectPerspectives = (props: { reportName: string }) =>
    createSelector(
        selectReportView(props),
        (reportView) => !!reportView ? { reportName: reportView.reportName, perspectives: reportView.perspectives, selectedPerspective: reportView.selectedPerspective } : null
    );
export const selectCurrentPerspective = (props: { reportName: string }) =>
    createSelector(
        selectPerspectives(props),
        (perspectives) => perspectives?.selectedPerspective
    );
